/**
 * One redaction helper, applied at every third-party sink.
 *
 * Some URLs in this app ARE credentials rather than addresses:
 *   /talent/sharing?token=…   grants or revokes permission to show someone
 *                             to an employer
 *   /reentry/verify?token=…   confirms an application
 *   GET /api/talent/consent?token=…
 *
 * Anything that forwards a URL off our infrastructure — Google Analytics,
 * Sentry events, Sentry breadcrumbs, session replay — has to pass it through
 * here first. Keeping this in its own module means analytics and Sentry share
 * exactly one definition instead of drifting apart.
 */

const CAPABILITY_PARAMS = [
  'token',
  'access_token',
  'refresh_token',
  'code',
  'key',
  'secret',
  'session'
]

export function redactUrl(href) {
  if (!href || typeof href !== 'string') return ''
  try {
    const base = typeof window !== 'undefined' ? window.location.origin : 'https://secondchance.dev'
    const u = new URL(href, base)
    for (const p of CAPABILITY_PARAMS) {
      if (u.searchParams.has(p)) u.searchParams.set(p, 'REDACTED')
    }
    return u.toString()
  } catch {
    // Unparseable — drop it rather than risk forwarding a raw credential.
    return ''
  }
}

/** Redact every URL-ish field on a Sentry breadcrumb, in place. */
export function redactBreadcrumb(crumb) {
  if (!crumb?.data) return crumb
  for (const field of ['url', 'to', 'from']) {
    if (typeof crumb.data[field] === 'string') {
      crumb.data[field] = redactUrl(crumb.data[field])
    }
  }
  return crumb
}

export { CAPABILITY_PARAMS }
